export default __webpack_public_path__ + "static/media/lb-png.9cca0553.webp";